module.exports = __webpack_public_path__ + "static/img/WxD.a055280.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/home/WxD.png
// module id = UZhw
// module chunks = 83